import { faCircle } from "@fortawesome/pro-solid-svg-icons";

import { Icon } from "src/base-components/Icon";
import { CaseTemplateVersionPublishState } from "src/clients/case-management/api";

export const TemplateVersionName: React.FC<{
  name: string;
  state: CaseTemplateVersionPublishState;
}> = ({ name, state }) => {
  return (
    <div className="flex items-center gap-1">
      <TemplateVersionStatusIndicator state={state} />
      {name}
    </div>
  );
};

export const TemplateVersionStatusIndicator: React.FC<{
  state: CaseTemplateVersionPublishState;
}> = ({ state }) => {
  return (
    <Icon
      color={
        state === CaseTemplateVersionPublishState.PUBLISHED
          ? "text-green-400"
          : "text-yellow-400"
      }
      icon={faCircle}
      size="3xs"
    />
  );
};
